import React, { useEffect } from 'react';
import { Card, Col, Row, Typography } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { ResponsePaymentGeneral } from '../../../types/common';
const { Text } = Typography;

interface InfoCardProps {
    paymentData: ResponsePaymentGeneral | undefined;
    packageName: string;
}

const PaymentAmount = (props: InfoCardProps) => {
    const { packageName, paymentData } = props;
    const [paymentPesos, setPaymentPeso] = React.useState("0");
    const [paymentCentavos, setPaymentCentavo] = React.useState(0);
    const [shortDateFormat, setShortDateFormat] = React.useState("");
    const [hasDebt, setHasDebt] = React.useState(false);
    const [paymentAmount, setPaymentAmount] = React.useState(0);

    useEffect(() => {
        if (paymentData) {
            const { hasDebt, payment } = paymentData;
            setHasDebt(hasDebt);

            const { datos } = payment || {};

            if (datos) {
                const { paymentLimitDate, amount, amountQty } = datos;

                if (paymentLimitDate) {
                    const [, mesStr, yearStr] = paymentLimitDate.split("-");
                    const mesNumMap: Record<string, string> = {
                        Ene: "01",
                        Feb: "02",
                        Mar: "03",
                        Abr: "04",
                        May: "05",
                        Jun: "06",
                        Jul: "07",
                        Ago: "08",
                        Sep: "09",
                        Oct: "10",
                        Nov: "11",
                        Dic: "12",
                    };

                    const monthShort = mesNumMap[mesStr];
                    const year = Number(yearStr);

                    setShortDateFormat(`${monthShort}-${year}`);
                }

                if (amount) {
                    const [peso, centavo] = amount.split('.');
                    setPaymentPeso(peso);
                    setPaymentCentavo(Number(centavo));
                }
                if (amountQty) {
                    setPaymentAmount(amountQty)
                }
            }
        }
    }, [paymentData]);

    return (
        <Card style={{ ...styles.rowRoot, backgroundColor: hasDebt ? '#e00614' : '#0055c2' }} bodyStyle={{ padding: 10 }}>
            <Row>
                <Col style={styles.colView} sm={24} md={12}>
                    <Text style={styles.textTitle}>{"Saldo a Pagar"}</Text>
                </Col>
                <Col sm={24} md={12}>
                    <Row>
                        <Col xs={24} style={styles.secondColView}>
                            <div style={styles.rowView}>
                                <Text
                                    style={styles.textPaymentAmount}>
                                    {"$" + paymentPesos}.
                                </Text>
                                <Text
                                    style={styles.textPaymentCents}>
                                    {paymentCentavos > 0 ? paymentCentavos : paymentCentavos + '0'}
                                </Text>
                            </div>
                        </Col>
                        <Col xs={24} style={styles.secondColView}>
                            <Text style={styles.textDescription}>
                                {packageName}
                            </Text>
                        </Col>
                        {
                            paymentAmount > 0 && (
                                <Col xs={24} style={styles.secondColView}>
                                    <Text style={styles.textDescription}>
                                        {"Periodo que cubre: "}&nbsp;
                                        <Text style={styles.textDescriptionBold}>
                                            {shortDateFormat}
                                        </Text>
                                    </Text>
                                </Col>
                            )
                        }
                    </Row>
                </Col>

            </Row>
        </Card>
    );
};

const styles = StyleSheet.create({
    rowRoot: {
        padding: 0,
        borderRadius: 15,
        boxShadow: "0px 0px 8px #00000029",
    },
    textTitle: {
        fontSize: 20,
        color: "white",
        fontWeight: 600,
    },
    textDescription: {
        color: "white",
    },
    textDescriptionBold: {
        color: "white",
        fontWeight: 600,
    },
    colView: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 20
    },
    secondColView: {
        display: 'flex',
        justifyContent: 'center'
    },
    secondColFull: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    rowView: {
        display: 'flex',
        flexDirection: 'row'
    },
    textPaymentAmount: {
        color: "#ffffff",
        fontSize: 25,
        fontWeight: 600,
    },
    textPaymentCents: {
        color: "#ffffff",
        fontSize: 16,
        paddingTop: 2,
        fontWeight: 600,
    },
});

export default PaymentAmount;
